"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareAnalyticsItemSchema = exports.getShareAnalyticsResponseSchema = exports.getShareAnalyticsParamsSchema = exports.createShareResponseSchema = exports.createShareBodySchema = exports.CouponSharingEntitySchema = exports.SharingMethodSchema = void 0;
const zod_1 = require("zod");
const common_schemas_1 = require("../base/common.schemas");
const api_schemas_1 = require("../base/api.schemas");
const timestamp_schemas_1 = require("../base/timestamp.schemas");
// ============================================
// INTERNAL SCHEMAS (Entity)
// ============================================
// Sharing method (from coupon_sharing.sharing_method CHECK constraint)
const _SharingMethodSchema = zod_1.z.enum(['whatsapp', 'sms', 'email', 'qr', 'link']);
// Coupon sharing entity schema matching database coupon_sharing table
// V1: Simplified - share_recipients and recipient_interactions tables removed (migration 029)
const _CouponSharingBaseSchema = zod_1.z.object({
    sharing_id: zod_1.z.number().int().positive(),
    coupon_id: zod_1.z.number().int().positive(),
    user_id: common_schemas_1.uuidSchema,
    share_code: zod_1.z.string().max(32),
    claim_code: zod_1.z.string().max(10),
    sharing_method: _SharingMethodSchema,
    recipient_count: zod_1.z.number().int().min(0),
    view_count: zod_1.z.number().int().min(0), // V1: Track link views
    claim_count: zod_1.z.number().int().min(0), // V1.1: Track claims
    expires_at: timestamp_schemas_1.timestampIsoSchema.nullable(),
    created_at: timestamp_schemas_1.timestampIsoSchema,
});
// ============================================
// ENTITY SCHEMAS (Export Aliases)
// ============================================
exports.SharingMethodSchema = _SharingMethodSchema;
exports.CouponSharingEntitySchema = _CouponSharingBaseSchema;
// ============================================
// CUSTOMER SHARING API SCHEMAS
// ============================================
// POST /sharing - Body (V1: Link sharing only, no recipient phone)
exports.createShareBodySchema = zod_1.z.object({
    userCouponId: zod_1.z.number().int().positive(),
    // V1: No recipientPhone - we generate a shareable link, user shares via WhatsApp manually
});
// POST /sharing - Response (V1: Returns share URL for link sharing)
exports.createShareResponseSchema = (0, api_schemas_1.dataResponseSchema)(zod_1.z.object({
    share_url: zod_1.z.string().url(), // Full URL for sharing: https://zlinkx.app/c/ABC123XY
    share_code: zod_1.z.string(), // Short code: ABC123XY
    claim_code: zod_1.z.string(), // V1.2: 4-digit numeric code for direct display on public page
}));
// ============================================
// SHARE ANALYTICS API SCHEMAS (Story 6.4)
// ============================================
// GET /sharing/analytics/:userCouponId - Params
exports.getShareAnalyticsParamsSchema = zod_1.z.object({
    userCouponId: zod_1.z.coerce.number().int().positive(),
});
// Internal: Individual share analytics item
const _ShareAnalyticsItemSchema = zod_1.z.object({
    sharing_id: zod_1.z.number().int(),
    share_code: zod_1.z.string(),
    claim_code: zod_1.z.string(),
    view_count: zod_1.z.number().int(),
    claim_count: zod_1.z.number().int(),
    created_at: timestamp_schemas_1.timestampIsoSchema,
});
// GET /sharing/analytics/:userCouponId - Response
exports.getShareAnalyticsResponseSchema = (0, api_schemas_1.dataResponseSchema)(zod_1.z.object({
    user_coupon_id: zod_1.z.number().int(),
    total_shares: zod_1.z.number().int(),
    total_views: zod_1.z.number().int(),
    shares: zod_1.z.array(_ShareAnalyticsItemSchema),
}));
// Export for reuse
exports.ShareAnalyticsItemSchema = _ShareAnalyticsItemSchema;
